import { Directive, ElementRef, HostListener } from '@angular/core';
import * as $ from "jquery";
@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  constructor(private _elementRef: ElementRef) { }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }
    if (!(targetElement.classList.contains('dd-button') || targetElement.classList.contains('item-name') || targetElement.classList.contains('dd-menu-item'))) {
      $('#ddMenu').removeClass('active')
    }
  }

}
